export default __webpack_public_path__ + "static/media/UAE.95de378b.svg";